<!-- @format -->

@if (
  moduleOrEducationStateObject.type === "EducationStateObject" ||
  (moduleOrEducationStateObject.type === "ModuleStateObject" && !moduleOrEducationStateObject.attainmentId)
) {
  @if (
    !isImplicit &&
    (moduleOrEducationStateObject.selectedCourseUnitIds.length > 0 ||
      moduleOrEducationStateObject.implicitCourseUnitIds.length > 0 ||
      moduleOrEducationStateObject.selectedCustomStudyDraftIds.length > 0 ||
      moduleOrEducationStateObject.selectedCustomCourseUnitAttainmentIds.length > 0)
  ) {
    <ul class="sis-pt-sm sis-pl-sm list-group-horizontal sis-plan-structure-module-content-list study-background">
      @for (courseUnitId of moduleOrEducationStateObject.selectedCourseUnitIds; track courseUnitId) {
        <li class="list-group-item col-sm-12 col-md-6 col-lg-4">
          <div class="sis-mb-sm sis-mr-sm">
            @if (!planStateObject.courseUnits[courseUnitId].isSubstituted) {
              <sis-plan-structure-course-unit
                [courseUnit]="planData.courseUnitsById[courseUnitId]"
                [planStateObject]="planStateObject"
                [planData]="planData"
                [headingLevel]="headingLevel"
                [showCompletionMethodSelection]="true">
              </sis-plan-structure-course-unit>
            }
            @if (planStateObject.courseUnits[courseUnitId].isSubstituted) {
              <sis-plan-structure-course-unit-substitutions
                [substitutedCourseUnit]="planData.courseUnitsById[courseUnitId]"
                [headingLevel]="headingLevel"
                [planValidationResult]="planValidationResult"
                [planStateObject]="planStateObject"
                [planData]="planData"></sis-plan-structure-course-unit-substitutions>
            }
          </div>
        </li>
      }
      @for (courseUnitId of moduleOrEducationStateObject.implicitCourseUnitIds; track courseUnitId) {
        <li class="list-group-item col-sm-12 col-md-6 col-lg-4">
          <div class="sis-mb-sm sis-mr-sm">
            <sis-plan-structure-implicit-course-unit
              [courseUnit]="planData.courseUnitsById[courseUnitId]"
              [planStateObject]="planStateObject"
              [planData]="planData"
              [headingLevel]="headingLevel"
              [showSkipLink]="true">
            </sis-plan-structure-implicit-course-unit>
          </div>
        </li>
      }
      @for (customStudyDraftId of moduleOrEducationStateObject.selectedCustomStudyDraftIds; track customStudyDraftId) {
        <li class="list-group-item col-sm-12 col-md-6 col-lg-4">
          <div class="sis-mb-sm sis-mr-sm">
            <sis-plan-structure-custom-study-draft
              [customStudyDraft]="planData.customStudyDraftsById[customStudyDraftId]"
              [headingLevel]="headingLevel">
            </sis-plan-structure-custom-study-draft>
          </div>
        </li>
      }
      @for (
        customCourseUnitAttainmentId of moduleOrEducationStateObject.selectedCustomCourseUnitAttainmentIds;
        track customCourseUnitAttainmentId
      ) {
        <li class="list-group-item col-sm-12 col-md-6 col-lg-4">
          <div class="sis-mb-sm sis-mr-sm">
            <sis-plan-structure-custom-course-unit-attainment
              [customCourseUnitAttainment]="getCustomCourseUnitAttainment(customCourseUnitAttainmentId)"
              [planStateObject]="planStateObject"
              [headingLevel]="headingLevel">
            </sis-plan-structure-custom-course-unit-attainment>
          </div>
        </li>
      }
    </ul>
  }
  @for (moduleId of moduleOrEducationStateObject.selectedModuleIds; track moduleId) {
    <sis-plan-structure-module
      [module]="getModule(moduleId)"
      [planValidationResult]="planValidationResult"
      [planStateObject]="planStateObject"
      [planData]="planData"
      [isImplicit]="false"
      [headingLevel]="headingLevel"></sis-plan-structure-module>
  }
  @for (customModuleAttainmentId of moduleOrEducationStateObject.selectedCustomModuleAttainmentIds; track customModuleAttainmentId) {
    <sis-plan-structure-custom-module-attainment
      [customModuleAttainment]="getCustomModuleAttainment(customModuleAttainmentId)"
      [planStateObject]="planStateObject"
      [planData]="planData"
      [headingLevel]="headingLevel">
    </sis-plan-structure-custom-module-attainment>
  }
}
@if (moduleOrEducationStateObject.type === "ModuleStateObject" && moduleOrEducationStateObject.attainmentId) {
  <sis-plan-structure-attainment-node-structure
    [attainmentNodes]="getModuleAttainment(moduleOrEducationStateObject.attainmentId)?.nodes"
    [planStateObject]="planStateObject"
    [planData]="planData"
    [headingLevel]="headingLevel">
  </sis-plan-structure-attainment-node-structure>
}
